import { convertError } from './converters';

import GLOBAL from '../configs/config_global';

// region Get Brewery List
export function getBreweryList(currentPage = 1, pageSize = 10, keyword = '', citySlug = 'denver', stateShortName = 'CO') {
    return new Promise((resolve, reject) => {
        let link =
            GLOBAL.FATHER_LINK + '/consumer/v1/breweries?' + 'sort_by=rating&sort_type=desc' + '&page=' + currentPage + '&per_page=' + pageSize
            + (keyword ? '&keyword=' + keyword.toLowerCase() : '')
            + `&city=${citySlug}&state=${stateShortName}`;

        fetch(link, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            timeout: 10000
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.hasOwnProperty('errors')) {
                    console.log('[SUCCESS] GET BREWERY LIST', response);
                    resolve({
                        data: response.data,
                        currentPage: response['current_page'],
                        lastPage: response['last_page'],
                        totalResult: response['total']
                    });
                }
                else {
                    console.log('[FAILED] GET BREWERY LIST', response);
                    reject(convertError(response.errors));
                }
            })
            .catch((error) => {
                console.log('[FAILED] GET BREWERY LIST', error.message);
                reject(error.message);
            });
    });
}
// endregion
